import { Injectable } from "@angular/core";
import { LinguaDTO } from "../dto/linguaDTO";
import { LinguaVO } from "../vo/linguaVO";
import { MapperInterface } from "./mapper-inteface";

@Injectable({
  providedIn: "root",
})
export class MapperLingua implements MapperInterface<LinguaDTO, LinguaVO> {
  constructor() {}
  convertVoToDto(vo: LinguaVO): LinguaDTO {
    if (vo != null) {
      const dto = new LinguaDTO();
      dto.id = vo.id;
      dto.codice = vo.codice;
      dto.nome = vo.nome;

      return vo;
    } else {
      return null;
    }
  }
  convertDtoToVo(dto: LinguaDTO): LinguaVO {
    if (dto != null) {
      const vo = new LinguaVO();
      vo.id = dto.id;
      vo.codice = dto.codice;
      vo.nome = dto.nome;
      vo.output = dto.codice + " - " + dto.nome;

      return vo;
    } else {
      return null;
    }
  }
  convertListVoToDto(e: LinguaVO[]): LinguaDTO[] {
    if (e != null) {
      return e.map((vo) => this.convertVoToDto(vo));
    } else {
      return null;
    }
  }
  convertListDtoToVo(t: LinguaDTO[]): LinguaVO[] {
    if (t != null) {
      return t.map((vo) => this.convertDtoToVo(vo));
    } else {
      return null;
    }
  }
}
